var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf10W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 20,
    height: 14,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Framesolutons-2",
    transform: "translate(15 18)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M20,6.275V7.764a2.292,2.292,0,0,1-.156.331.847.847,0,0,1-.755.368H5.807a.845.845,0,0,1-.916-.925c0-.372,0-.744,0-1.116a.843.843,0,0,1,.875-.879q1.432,0,2.864,0H18.943C19.583,5.542,19.776,5.675,20,6.275Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M20,.713V2.2a.874.874,0,0,1-.653.688.953.953,0,0,1-.209.019H5.751a.823.823,0,0,1-.859-.869c0-.39,0-.779,0-1.169A.839.839,0,0,1,5.745.008q1.362,0,2.723,0C11.947.007,15.425.014,18.9,0A.979.979,0,0,1,20,.713Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M20,11.8v1.488a.949.949,0,0,1-.7.709H5.59c-.564-.221-.7-.424-.7-1.052v-.567q0-.2,0-.407a.83.83,0,0,1,.867-.88H19.121a.811.811,0,0,1,.846.648A.312.312,0,0,0,20,11.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M3.5,13.153a.872.872,0,0,1-.69.847H.669a2.549,2.549,0,0,1-.361-.2.779.779,0,0,1-.3-.632c0-.425-.007-.851,0-1.276a.827.827,0,0,1,.807-.8c.6,0,1.195,0,1.792,0a.834.834,0,0,1,.9.871C3.515,12.361,3.514,12.757,3.5,13.153Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M3.5,7.613a.838.838,0,0,1-.87.849c-.3,0-.6,0-.9,0s-.586,0-.878,0A.835.835,0,0,1,.006,7.6c0-.4,0-.8,0-1.2a.836.836,0,0,1,.832-.849c.609-.007,1.219-.006,1.828,0a.84.84,0,0,1,.839.883q.017.593,0,1.187Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1.76.455h0Zm-.553,0c-.114,0-.228,0-.342,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M3.5.877A.837.837,0,0,0,2.7.01Q1.756,0,.807.009A.831.831,0,0,0,.007.8c-.009.437-.01.874,0,1.31a.813.813,0,0,0,.819.8c.3,0,.609,0,.913,0h.9A.823.823,0,0,0,3.5,2.08C3.516,1.68,3.516,1.277,3.5.877ZM1.76.455h0Zm-.553,0-.342,0C.979.454,1.093.454,1.207.454Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M.865.456c.114,0,.228,0,.342,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M2.027.454h0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf10W);
export default __webpack_public_path__ + "static/media/icon-wf-10-w.833b769045a1fe51c3b5843523267056.svg";
export { ForwardRef as ReactComponent };